var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"greenBtn",class:_vm.cusprop.class,on:{"click":_vm.goFun}},[_vm._v(_vm._s(_vm.text || "详情")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }